import {
  IAttendee,
  TComplexSectionData,
} from 'legacy/lut/classes/models/partner360/ELT/IELTFormData'
import { getFormedChangedComplexData } from 'legacy/lut/components/widgets/public/partner360/ELT/helpers/getFormedChangedCompexData'
import { StyledTable } from 'legacy/lut/components/widgets/public/partner360/ELT/ui/styledComponents/styledTable/StyledTable'
import { useCallback, useMemo } from 'react'

import { getFormedEltTranslation } from '../../../../helpers/getFormedEltTranslation'

import { getHpAttendeesColumns } from './getHpAttendeesColumns'

interface IProps {
  data: IAttendee[]
  updateFormData: (data: TComplexSectionData) => void
}

export const HpAttendees = ({ data, updateFormData }: IProps) => {
  const onChange = useCallback(
    (field: string, index: number) => (value: string) => {
      const newData = getFormedChangedComplexData({ field, value, index, data })
      updateFormData(newData)
    },
    [data]
  )

  const addRow = useCallback(() => {
    const newData: IAttendee[] = [...data, { Email: '', Name: '', Title: '' }]
    updateFormData(newData)
  }, [data.length, data])

  const deleteLastRow = useCallback(() => {
    const newData = data.slice(0, -1)
    updateFormData(newData)
  }, [data])

  const deleteRow = useCallback(
    (index: number) => {
      const newData = data
      newData.splice(index, 1)
      updateFormData(newData)
    },
    [data]
  )

  const canAddNewRow = useMemo(() => {
    const emptyRows = data.filter((el) => !el.Name && !el.Email && !el.Title)
    return emptyRows.length === 0
  }, [JSON.stringify(data)])

  const columns = useMemo(() => getHpAttendeesColumns({ onChange }), [data])
  return (
    <div>
      <StyledTable<IAttendee>
        title={getFormedEltTranslation('hp-attendees')}
        columns={columns}
        items={data}
        addRow={addRow}
        deleteLastRow={deleteLastRow}
        deleteRow={deleteRow}
        canAddNewRow={canAddNewRow}
        maxLen={5}
      />
    </div>
  )
}
